import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function SellsTeam() {
  const [userPortalData, setuserPortalData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("financeUserPortal", setuserPortalData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleDownloadExcel = () => {
    const filteredData = userPortalData.map((item, index) => ({
      "Sr. No": index + 1,
      Email: item.email || "N/A",
      Password: item.password || "N/A",
      Name: item.name || "N/A",
      "Mobile No": item.mobilno || "N/A",
      DOB: item.dob || "N/A",
      "Father's Name": item.fatherName || "N/A",
      "Mother's Name": item.motherName || "N/A",
      Gender: item.gender || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTeamData");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "SalesTeamData.xlsx");
  };
  

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <div style={{ width: "100%", overflowX: "auto", paddingTop: "30px" }}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <Link to="/employeeform" className="custom-link">
          + Add Employee
        </Link>
        <button className="btn btn-success" onClick={handleDownloadExcel}>
          ⬇️ Download Excel
        </button>
      </div>

      <Table bordered responsive>
        <thead>
          <tr>
            <th style={headerStyle}>Sr.n.</th>
            <th style={headerStyle}>Email</th>
            <th style={headerStyle}>Password</th>
            <th style={headerStyle}>Name</th>
            <th style={headerStyle}>Mobile No</th>
            <th style={headerStyle}>DOB</th>
            <th style={headerStyle}>Father's Name</th>
            <th style={headerStyle}>Mother's Name</th>
            <th style={headerStyle}>Gender</th>
          </tr>
        </thead>
        <tbody>
          {userPortalData.length === 0 ? (
            <tr>
              <td colSpan={9} style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            userPortalData.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "center" }}>{item.email || "N/A"}</td>
                <td style={{ textAlign: "center" }}>
                  {item.password || "N/A"}
                </td>
                <td style={{ textAlign: "center" }}>{item.name || "N/A"}</td>
                <td style={{ textAlign: "center" }}>{item.mobilno || "N/A"}</td>
                <td style={{ textAlign: "center" }}>{item.dob || "N/A"}</td>
                <td style={{ textAlign: "center" }}>
                  {item.fatherName || "N/A"}
                </td>
                <td style={{ textAlign: "center" }}>
                  {item.motherName || "N/A"}
                </td>
                <td style={{ textAlign: "center" }}>{item.gender || "N/A"}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

const headerStyle = {
  backgroundColor: "black",
  color: "white",
  textAlign: "center",
};

export default SellsTeam;
